var render, staticRenderFns
import script from "./Custom.vue?vue&type=script&lang=js&"
export * from "./Custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75019a7f",
  null
  
)

export default component.exports